import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';


const styles = theme => ({
    wrapper: {
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -12,
    },
});


class CircleProgressButton extends React.Component {
    state = {
    }

    render() {
        const { classes, children, className, loading, progressSize, disabled, subClasses, fullWidth, ...other } = this.props;

        return (
            <div 
                className={classes.wrapper}
                style={{width: fullWidth ? '100%' : 'auto'}}
            >
                <Button
                    className={className}
                    disabled={disabled || loading}
                    {...other}
                    classes={subClasses}
                    fullWidth={fullWidth}
                >
                    {children}
                </Button>
                {loading && <CircularProgress size={progressSize ? progressSize : 24} className={classes.buttonProgress} />}
            </div>
        );
    }
}

export default withStyles(CircleProgressButton, styles);